import { Tabs, type TabsProps } from 'antd'
import clsx from 'clsx'

import './styles.scss'

export function BorderlessTabs({
  className,
  size = 'small',
  ...props
}: TabsProps) {
  return (
    <Tabs
      className={clsx('tabs-without-border', className)}
      size={size}
      {...props}
    />
  )
}
